// =============================================================================
// Capacity Pool Core Types
// =============================================================================
export const CAPACITY_POOL_SCOPES = ['installation', 'user', 'project'];
export const CAPACITY_SOURCE_KINDS = [
    'cloud-provider-credential',
    'registered-runner',
    'instant-runtime',
];
export const CAPACITY_CREDENTIAL_SOURCES = ['user', 'project', 'platform'];
export const CAPACITY_POOL_STATUSES = ['active', 'disabled', 'deleted'];
export const CAPACITY_POOL_CONFIGURATION_STATES = [
    'configured-ready',
    'configured-empty',
    'source-disabled',
    'catalog-unavailable',
    'migration-pending',
];
export const DEFAULT_CAPACITY_POOL_EFFECTIVE_STATES = [
    'unconfigured',
    ...CAPACITY_POOL_CONFIGURATION_STATES,
];
export const CAPACITY_POOL_STRATEGIES = ['balanced', 'pack', 'spread', 'smallest-fit'];
export const DEFAULT_CAPACITY_POOL_DEPLOYMENT_STRATEGY = 'smallest-fit';
/** Default maximum number of managed workspace nodes per user in one capacity pool. */
export const DEFAULT_CAPACITY_POOL_MAX_NODES = 3;
export const CAPACITY_EXHAUSTION_POLICIES = ['queue', 'fail', 'fallback-chain'];
export const CAPACITY_WORKLOAD_ROLES = ['workspace', 'deployment'];
export const CAPACITY_PLACEMENT_CREDENTIAL_SOURCES = [
    'user',
    'project',
    'platform',
    'self-hosted',
];
// =============================================================================
// Capacity Pool API Response Types
// =============================================================================
export const SAFE_EFFECTIVE_CAPACITY_POOL_REASONS = [
    'no-capacity-pool-configured',
    'configured-default-pool-has-no-active-candidates',
    'configured-default-pool-sources-disabled',
    'configured-default-pool-catalog-last-known-unavailable',
    'configured-default-pool-migration-pending',
];
export function isCapacityPoolScope(value) {
    return typeof value === 'string' && CAPACITY_POOL_SCOPES.includes(value);
}
export function isCapacitySourceKind(value) {
    return typeof value === 'string' && CAPACITY_SOURCE_KINDS.includes(value);
}
export function isCapacityCredentialSource(value) {
    return (typeof value === 'string' && CAPACITY_CREDENTIAL_SOURCES.includes(value));
}
export function isCapacityPoolStatus(value) {
    return typeof value === 'string' && CAPACITY_POOL_STATUSES.includes(value);
}
export function isCapacityPoolConfigurationState(value) {
    return (typeof value === 'string' &&
        CAPACITY_POOL_CONFIGURATION_STATES.includes(value));
}
export function isCapacityPoolStrategy(value) {
    return (typeof value === 'string' && CAPACITY_POOL_STRATEGIES.includes(value));
}
export function isCapacityExhaustionPolicy(value) {
    return (typeof value === 'string' && CAPACITY_EXHAUSTION_POLICIES.includes(value));
}
export function isCapacityWorkloadRole(value) {
    return (typeof value === 'string' && CAPACITY_WORKLOAD_ROLES.includes(value));
}
export function isCapacityPlacementCredentialSource(value) {
    return (typeof value === 'string' &&
        CAPACITY_PLACEMENT_CREDENTIAL_SOURCES.includes(value));
}
//# sourceMappingURL=capacity-pool.js.map